import { render, staticRenderFns } from "./UserSubmission.vue?vue&type=template&id=e393a7a8"
import script from "./UserSubmission.vue?vue&type=script&lang=js"
export * from "./UserSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports